export enum InnoDynamicProperties {
  Catalog = "OrderLineItem_Origin_Catalog",
  Wishlist = "OrderLineItem_Origin_Wishlist",
}
